import {
  gasGetGasList,
  gasAddGas,
  gasUpdateGas,
  gasDeleteGas
} from '@/api/api'

const state = {
  gasList: [],
  gasTotal: 0
}

const getters = {
  gasList: state => state.gasList,
  gasTotal: state => state.gasTotal
}

const actions = {
  loadGasList ({ dispatch }, parm) {
    return gasGetGasList(parm).then((data) => {
      data.forEach((item) => {
        item['simpleName'] = item['simpleName1'] || item['simpleName2']
      })
      dispatch('setGasList', data)
    })
  },
  addGas ({ commit }, parm) {
    return gasAddGas(parm)
  },
  updateGas ({ commit }, parm) {
    return gasUpdateGas(parm)
  },
  delGas ({ commit }, gasId) {
    return gasDeleteGas(gasId)
  },
  setGasList ({ commit }, data) {
    commit('setGasList', data)
  },
  setGasTotal ({ commit }, data) {
    commit('setGasTotal', data)
  }
}

const mutations = {
  setGasList (state, data) {
    state.gasList = data
  },
  setGasTotal (state, data) {
    state.gasTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/gas.js